<form class="hidden">
  <button
    #acceptPaymentButton
    type="button"
    class="AcceptUI"
    data-billingAddressOptions='{"show":true, "required":true}'
    [attr.data-apiLoginID]="authNetAPILoginID"
    [attr.data-clientKey]="authNetClientKey"
    data-acceptUIFormBtnTxt="Submit"
    data-acceptUIFormHeaderTxt="Payment Information"
    data-paymentOptions='{"showCreditCard": true, "showBankAccount": true}'
    data-responseHandler="acceptJSResponseHandler"
    [disabled]="paymentProcessing"
  >
    <span class="h-6 w-6"><app-credit-card-icon></app-credit-card-icon></span>
    Pay with a New Method
  </button>
</form>

@if (errorFetchingInvoice) {
  <div class="text-error">
    <p>{{ errorFetchingInvoice }}</p>
  </div>
} @else if (errorFetchingTenant) {
  <div class="text-error">
    <p>{{ errorFetchingTenant }}</p>
  </div>
} @else if (loadingTenant || loadingInvoice) {
  <div class="flex w-full justify-center">
    <div class="skeleton mt-5 h-96 w-full max-w-3xl"></div>
  </div>
} @else if (hasOrder && tenant) {
  <div
    class="w-full max-w-4xl rounded-md border border-base-content/20 p-4 sm:mt-5 sm:border-2"
  >
    <!-- Full sized checkout details -->
    <div class="hidden sm:block">
      <div class="flex justify-between">
        <div class="text-sm">
          <p class="mb-2 text-4xl">Checkout</p>
          <p class="mb-4 text-2xl">
            {{ orderTotal | currency: 'USD' }}
          </p>
          <div class="flex">
            <div class="mr-12">
              <div class="table-row">
                <div
                  class="table-cell pb-1 pr-3 text-right text-base-content/70"
                >
                  Account #:
                </div>
                <div class="table-cell pb-1">{{ tenant.account_number }}</div>
              </div>
              <div class="table-row">
                <div
                  class="table-cell pb-1 pr-3 text-right text-base-content/70"
                >
                  Company:
                </div>
                <div class="table-cell pb-1">{{ tenant.company }}</div>
              </div>
              @if (!isDES) {
                <div class="table-row">
                  <div
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    Order #:
                  </div>
                  <div class="table-cell pb-1">
                    {{ orderNumber }}
                  </div>
                </div>
              }
              @if (isAdmin && currentView === 'admin') {
                @if (desktopInvoice) {
                  <div class="table-row">
                    <div
                      class="table-cell pb-1 pr-3 text-right text-base-content/70"
                    >
                      Sales Rep:
                    </div>
                    <div class="table-cell pb-1">
                      {{ getSalesRepNames(desktopInvoice.sales_reps) }}
                    </div>
                  </div>
                } @else if (apiInvoice) {
                  <div class="table-row">
                    <div
                      class="table-cell pb-1 pr-3 text-right text-base-content/70"
                    >
                      Sales Rep:
                    </div>
                    <div class="table-cell pb-1">
                      {{ getSalesRepNames(apiInvoice.sales_reps) }}
                    </div>
                  </div>
                }
              }
              @if (!isDES) {
                <div class="table-row">
                  <div
                    class="table-cell pb-1 pr-3 text-right text-base-content/70"
                  >
                    Created on:
                  </div>
                  <div class="table-cell pb-1">
                    {{ orderCreatedAt | date: 'MM/dd/yyyy' }}
                  </div>
                </div>
              }
            </div>

            <div>
              <div class="table-row">
                <p class="table-cell text-base-content/70">Shipping Address:</p>
              </div>
              <div class="table-row">
                <div class="table-cell max-w-60 pb-2">
                  <p>{{ tenant.address }} {{ tenant.address2 }}</p>
                  <p>{{ tenant.city }}, {{ tenant.st }} {{ tenant.zip }}</p>
                </div>
              </div>
              @if (tenant.billing_address) {
                <div class="table-row">
                  <p class="table-cell text-base-content/70">
                    Billing Address:
                  </p>
                </div>
                <div class="table-row">
                  <div class="table-cell max-w-60 pb-2">
                    <p>
                      {{ tenant.billing_address }} {{ tenant.billing_address2 }}
                    </p>
                    <p>
                      {{ tenant.billing_city }}, {{ tenant.billing_st }}
                      {{ tenant.billing_zip }}
                    </p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="h-24 w-24">
          <app-file-invoice-icon
            class="text-gray-600 dark:text-gray-300 [&_path]:stroke-1"
          ></app-file-invoice-icon>
        </div>
      </div>
      <div class="mt-4 overflow-x-auto">
        <table class="table table-zebra">
          <thead class="text-sm">
            @if (desktopInvoice) {
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Type</th>
                <!-- hide duration when using manual values -->
                @if (!desktopInvoice.desktop_invoice.use_manual_values) {
                  <th class="font-medium">Duration</th>
                }
                <th class="font-medium">Quantity</th>
                <th class="font-medium">New Expiration</th>
                <th class="text-right font-medium">Price</th>
                <th class="text-right font-medium">Total</th>
              </tr>
            } @else if (desPurchase) {
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Credits</th>
                <th class="font-medium">Price / 1,000</th>
                <th class="text-right font-medium">Total</th>
              </tr>
            } @else if (apiInvoice) {
              <tr>
                <th class="font-medium">Product</th>
                <th class="font-medium">Transaction Month</th>
                <th class="font-medium">Job Count</th>
                <th class="text-right font-medium">Price</th>
              </tr>
            }
          </thead>
          <tbody>
            @if (desktopInvoice) {
              @for (el of groupedLicenseInvoiceDetails; track el) {
                <tr>
                  <td>{{ el.license.license_with_product.product.title }}</td>
                  <td>
                    {{ getLicenseType(el.license.license_with_product) }}
                  </td>
                  @if (!desktopInvoice.desktop_invoice.use_manual_values) {
                    <td>
                      {{
                        el.license.license_with_product.product_variant
                          .display_duration
                      }}
                    </td>
                  }
                  <td>{{ el.count }}</td>
                  <td>
                    {{
                      el.license.new_expiration_date
                        | date: 'MM/dd/yyyy' : 'UTC'
                    }}
                  </td>
                  <td class="text-right">
                    {{ el.license.base_amount | currency: 'USD' }}
                  </td>
                  <td class="text-right">
                    {{ el.license.base_amount * el.count | currency: 'USD' }}
                  </td>
                </tr>
              }
            } @else if (desPurchase) {
              <tr>
                <td>DES Credits</td>
                <td>{{ desPurchase.credits | number }}</td>
                <td>{{ desPricePerThousand | currency: 'USD' }}</td>
                <td class="text-right">
                  {{ desPurchase.total_amount | currency: 'USD' }}
                </td>
              </tr>
            } @else if (apiInvoice && apiProduct) {
              <tr>
                <td>{{ apiProduct.title }}</td>
                <td>
                  {{
                    getDisplayTransactionMonth(
                      apiInvoice.api_invoice.transaction_yyyymm
                    ) | date: 'MMMM, yyyy'
                  }}
                </td>
                <td>{{ apiInvoice.api_invoice.job_count }}</td>
                <td class="text-right">
                  {{ apiInvoice.api_invoice.base_amount | currency: 'USD' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="w-100 mt-4 flex">
        @if (desktopInvoice?.desktop_invoice?.notes) {
          <div class="pl-4 text-sm">
            <p class="pb-0 pr-3 text-base-content/70">Memo:</p>
            <p class="mt-1 whitespace-pre-wrap">
              {{ desktopInvoice?.desktop_invoice?.notes }}
            </p>
          </div>
        }
        <div class="ml-auto w-48">
          <table class="table table-sm">
            <tbody>
              <tr>
                <td>Subtotal:</td>
                <td class="pr-4 text-right">
                  {{ orderBase | currency: 'USD' }}
                </td>
              </tr>
              <tr>
                <td>Tax:</td>
                <td class="pr-4 text-right">
                  {{ orderTax | currency: 'USD' }}
                </td>
              </tr>
              <tr>
                <td>Total:</td>
                <td class="pr-4 text-right">
                  {{ orderTotal | currency: 'USD' }}
                </td>
              </tr>
            </tbody>
          </table>
          @if (showBackToCartButton()) {
            <div class="mt-4 w-full text-right">
              <button
                [routerLink]="'/cart'"
                class="btn btn-outline btn-sm ml-auto"
              >
                Back to Cart
              </button>
            </div>
          } @else if (apiInvoice) {
            <div class="mt-4 w-full text-right">
              <button
                [routerLink]="['/api-job-logs']"
                [queryParams]="{
                  month: apiInvoice.api_invoice.transaction_yyyymm,
                  tenant_id: isAdmin ? tenant.id : null,
                }"
                class="btn btn-outline btn-sm ml-auto"
              >
                Go to Job Logs
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Mobile checkout details -->
    <div class="sm:hidden">
      <div class="prose">
        <h1 class="mb-2">Checkout</h1>
        <h3 class="mb-4 mt-0">
          {{ orderTotal | currency: 'USD' }}
        </h3>
      </div>
      <div>
        <div class="flex justify-between pb-1">
          <p class="text-base-content/70">Account #:</p>
          <div class="text-right">{{ tenant.account_number }}</div>
        </div>
        <div class="flex justify-between pb-1">
          <p class="text-base-content/70">Company:</p>
          <div>{{ tenant.company }}</div>
        </div>
        <div class="flex justify-between pb-1">
          <p class="text-base-content/70">Order #:</p>
          <div>
            {{ orderNumber }}
          </div>
        </div>
        @if (isAdmin) {
          @if (desktopInvoice) {
            <div class="flex justify-between pb-1">
              <p class="text-base-content/70">Sales Rep:</p>
              <div>{{ getSalesRepNames(desktopInvoice.sales_reps) }}</div>
            </div>
          } @else if (apiInvoice) {
            <div class="flex justify-between pb-1">
              <p class="text-base-content/70">Sales Rep:</p>
              <div>{{ getSalesRepNames(apiInvoice.sales_reps) }}</div>
            </div>
          }
        }
        <div class="flex justify-between pb-1">
          <p class="text-base-content/70">Created On:</p>
          <div>
            {{ orderCreatedAt | date: 'MM/dd/yyyy' }}
          </div>
        </div>
      </div>

      <div class="my-4 w-full border-2 border-base-content/50"></div>
      <div>
        <div class="mb-4 flex justify-between">
          <p class="text-xl font-bold">Products</p>
          @if (showBackToCartButton()) {
            <div class="w-full text-right">
              <button
                [routerLink]="['/cart']"
                class="btn btn-outline btn-sm ml-auto"
              >
                Back to Cart
              </button>
            </div>
          }
        </div>
        @if (desktopInvoice) {
          @for (el of groupedLicenseInvoiceDetails; track el) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Product:</p>
                <p>{{ el.license.license_with_product.product.title }}</p>
              </div>
              @if (!desktopInvoice.desktop_invoice.use_manual_values) {
                <div class="flex">
                  <p class="pb-1 pr-3 text-base-content/70">Duration:</p>
                  <p>
                    {{
                      el.license.license_with_product.product_variant
                        .display_duration
                    }}
                  </p>
                </div>
              }
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">New Expiration:</p>
                <p>
                  {{
                    el.license.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                  }}
                </p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                <p>{{ getLicenseType(el.license.license_with_product) }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Quantity:</p>
                <p>{{ el.count }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Price:</p>
                <p>{{ el.license.base_amount | currency: 'USD' }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Total:</p>
                <p>
                  {{ el.license.base_amount * el.count | currency: 'USD' }}
                </p>
              </div>
            </div>
          }
        } @else if (desPurchase) {
          <div class="my-2 w-full rounded-lg border border-base-content/20 p-4">
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Product:</p>
              <p>DES Credits</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Credits:</p>
              <p>{{ desPurchase.credits | number }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Price / 1,000:</p>
              <p>{{ desPricePerThousand | currency: 'USD' }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Total:</p>
              <p>{{ desPurchase.total_amount | currency: 'USD' }}</p>
            </div>
          </div>
        } @else if (apiInvoice && apiProduct) {
          <div class="my-2 w-full rounded-lg border border-base-content/20 p-4">
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Product:</p>
              <p>{{ apiProduct.title }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Transaction Month:</p>
              <p>
                {{
                  getDisplayTransactionMonth(
                    apiInvoice.api_invoice.transaction_yyyymm
                  ) | date: 'MMMM, yyyy'
                }}
              </p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Job Count:</p>
              <p>
                {{ apiInvoice.api_invoice.job_count }}
              </p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Price:</p>
              <p>{{ apiInvoice.api_invoice.base_amount | currency: 'USD' }}</p>
            </div>
          </div>
        }
      </div>
      <div class="my-4 w-full border-2 border-base-content/20"></div>
      <div>
        <p class="mb-2 text-xl font-bold">Address Info</p>
        <div class="mt-2 flex flex-col">
          <p class="pb-1 pr-3 text-base-content/70">Shipping Address</p>
          <div class="pb-1">
            {{ tenant.address }}, {{ tenant.address2 }}, {{ tenant.city }},
            {{ tenant.st }}, {{ tenant.zip }}
          </div>
        </div>
        @if (tenant.billing_address) {
          <div class="flex flex-col">
            <p class="pb-1 pr-3 text-base-content/70">Billing Address</p>
            <div class="pb-1">
              {{ tenant.billing_address }}, {{ tenant.billing_address2 }},
              {{ tenant.billing_city }}, {{ tenant.billing_st }},
              {{ tenant.billing_zip }}
            </div>
          </div>
        }
      </div>
      @if (desktopInvoice?.desktop_invoice?.notes) {
        <div class="my-2 w-full border-2 border-base-content/50"></div>
        <div>
          <p class="mb-2 text-xl font-bold">Memo</p>
          <div class="mt-4">
            <p class="whitespace-pre-wrap">
              {{ desktopInvoice?.desktop_invoice?.notes }}
            </p>
          </div>
        </div>
      }
      <div class="my-4 w-full border-2 border-base-content/50"></div>
      <div>
        <p class="mb-2 text-xl font-bold">Order Summary</p>
        <div class="flex justify-between">
          <p class="pb-1 pr-3 text-base-content/70">Subtotal:</p>
          <div class="pb-1 text-right">
            {{ orderBase | currency: 'USD' }}
          </div>
        </div>
        <div class="flex justify-between">
          <p class="pb-1 pr-3 text-base-content/70">Tax:</p>
          <div class="pb-1 text-right">
            {{ orderTax | currency: 'USD' }}
          </div>
        </div>
        <div class="flex justify-between">
          <p class="pb-1 pr-3 text-base-content/70">Total:</p>
          <div class="pb-1 text-right">
            {{ orderTotal | currency: 'USD' }}
          </div>
        </div>
      </div>
    </div>

    @if (paymentError) {
      <div class="mt-4 text-center text-error">
        {{ paymentError }}
      </div>
      @if (paymentStatusDescription) {
        <div class="text-center text-sm text-error">
          {{ paymentStatusDescription }}
        </div>
      }
    }

    <div class="divider hidden sm:flex"></div>
    <div class="my-4 w-full border-2 border-base-content/50 sm:hidden"></div>

    @if (savedPaymentMethods && savedPaymentMethods.length > 0) {
      <div class="mt-4 flex flex-col items-center">
        @for (paymentMethod of savedPaymentMethods; track paymentMethod) {
          <div
            class="min-w-sm m-2 w-full max-w-sm rounded-lg border border-base-content/20 p-4"
          >
            <div class="flex flex-col sm:flex-row">
              @if (
                paymentMethod.is_default ||
                (isAPI && paymentMethod.is_api_default)
              ) {
                <div class="mt-5"></div>
              }
              <div class="flex flex-col">
                <div class="flex">
                  <input
                    class="radio self-center"
                    type="radio"
                    name="saved-payment-method"
                    [id]="paymentMethod.id"
                    [value]="paymentMethod.id"
                    (change)="selectedSavedPaymentMethod = paymentMethod"
                  />
                  <p class="ml-4 self-center text-lg">
                    @if (paymentMethod.payment_type === 'bank') {
                      <span class="h-6 w-6"
                        ><app-building-icon></app-building-icon
                      ></span>
                    } @else if (paymentMethod.card_type === 'Visa') {
                      <app-visa-icon></app-visa-icon>
                    } @else if (paymentMethod.card_type === 'MasterCard') {
                      <app-mastercard-icon></app-mastercard-icon>
                    } @else if (paymentMethod.card_type === 'AmericanExpress') {
                      <app-american-express-icon></app-american-express-icon>
                    } @else if (paymentMethod.card_type === 'Discover') {
                      <app-discover-icon></app-discover-icon>
                    } @else if (paymentMethod.card_type === 'JCB') {
                      <app-jcb-icon></app-jcb-icon>
                    } @else if (paymentMethod.card_type === 'DinersClub') {
                      <app-diners-club-icon></app-diners-club-icon>
                    } @else {
                      <p class="text-lg">{{ paymentMethod.card_type }}</p>
                    }
                  </p>
                  <p class="ml-2 self-center text-base">
                    @if (paymentMethod.payment_type === 'bank') {
                      {{ bankAccountTypeLabel(paymentMethod) }} ••••
                    } @else {
                      ••••
                    }
                    {{ paymentMethod.last_4_digits }}
                  </p>
                  @if (paymentMethod.payment_type !== 'bank') {
                    <p class="ml-4 self-center text-sm">
                      Exp: {{ paymentMethod.card_expiration }}
                    </p>
                  }
                </div>
              </div>
              <div
                class="my-auto ml-auto flex flex-col items-end gap-1 sm:flex-row sm:items-center"
              >
                @if (!isAPI) {
                  @if (paymentMethod.is_default) {
                    <p class="my-auto text-sm italic sm:mr-4">Default</p>
                  }
                } @else {
                  @if (paymentMethod.is_api_default) {
                    <p class="my-auto text-sm italic sm:mr-4">API default</p>
                  } @else if (paymentMethod.is_default) {
                    <p class="my-auto text-sm italic sm:mr-4">Default</p>
                  }
                }
              </div>
            </div>
          </div>
        }
        <button
          class="btn btn-primary mt-2"
          (click)="payWithSelectedMethod()"
          [disabled]="!selectedSavedPaymentMethod || paymentProcessing"
        >
          Pay with Selected Saved Payment Method
          @if (paymentProcessing) {
            <div class="absolute flex h-full">
              <div class="loading loading-spinner">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          }
        </button>
      </div>
      <div class="divider my-4"></div>
    }
    <div class="relative mb-2">
      <div class="flex justify-center">
        <form>
          <button
            class="btn btn-primary"
            [disabled]="paymentProcessing"
            (click)="payWithNewCard()"
          >
            <span class="h-6 w-6"
              ><app-credit-card-icon></app-credit-card-icon
            ></span>
            Pay with a New Method
          </button>
        </form>
        @if (paymentProcessing) {
          <div class="absolute flex h-full">
            <div class="loading loading-spinner">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
